import type { FrAupaFormula, FrAupaPolicyItem } from '../fr-aupa-insurance.ts'

/** How each formula carries the guarantee. A formula absent from the record does not cover it at all. */
export type FrAupaCoverByFormula = Partial<Record<FrAupaFormula, 'included' | 'optional'>>

const INCLUDED_IN_ALL_FORMULAS = {
  'third-party': 'included',
  'third-party-plus': 'included',
  'all-risks': 'included',
} as const satisfies FrAupaCoverByFormula
const INCLUDED_FROM_THIRD_PARTY_PLUS = {
  'third-party-plus': 'included',
  'all-risks': 'included',
} as const satisfies FrAupaCoverByFormula
const INCLUDED_FROM_ALL_RISKS = { 'all-risks': 'included' } as const satisfies FrAupaCoverByFormula
const OPTIONAL_FROM_ALL_RISKS = { 'all-risks': 'optional' } as const satisfies FrAupaCoverByFormula
const OPTIONAL_FROM_THIRD_PARTY_PLUS = {
  'third-party-plus': 'optional',
  'all-risks': 'optional',
} as const satisfies FrAupaCoverByFormula
const OPTIONAL_IN_ALL_FORMULAS = {
  'third-party': 'optional',
  'third-party-plus': 'optional',
  'all-risks': 'optional',
} as const satisfies FrAupaCoverByFormula

export const frAupaCoverByPolicyItem_v1_0_0: Record<FrAupaPolicyItem, FrAupaCoverByFormula> = {
  civilLiability: INCLUDED_IN_ALL_FORMULAS,
  operatingLiability: INCLUDED_IN_ALL_FORMULAS,
  ecologicalDamage: INCLUDED_IN_ALL_FORMULAS,
  criminalDefenseAndRecourse: INCLUDED_IN_ALL_FORMULAS,
  driverProtection: INCLUDED_IN_ALL_FORMULAS,
  glass: INCLUDED_FROM_THIRD_PARTY_PLUS,
  naturalDisasters: INCLUDED_FROM_THIRD_PARTY_PLUS,
  technologicalDisasters: INCLUDED_FROM_THIRD_PARTY_PLUS,
  climateEvents: INCLUDED_FROM_THIRD_PARTY_PLUS,
  terrorism: INCLUDED_FROM_THIRD_PARTY_PLUS,
  fire: INCLUDED_FROM_THIRD_PARTY_PLUS,
  theft: INCLUDED_FROM_THIRD_PARTY_PLUS,
  allAccidentDamage: INCLUDED_FROM_ALL_RISKS,
  enhancedCompensation: OPTIONAL_FROM_ALL_RISKS,
  extendedDriver: OPTIONAL_IN_ALL_FORMULAS,
  vehicleEquipment: OPTIONAL_FROM_THIRD_PARTY_PLUS,
  vehicleContents: OPTIONAL_FROM_THIRD_PARTY_PLUS,
  reducedDeductible: OPTIONAL_FROM_THIRD_PARTY_PLUS,
  assistance: INCLUDED_IN_ALL_FORMULAS,
}

export function getFrAupaPolicyItemCover_v1_0_0(policyItemName: FrAupaPolicyItem): FrAupaCoverByFormula {
  return frAupaCoverByPolicyItem_v1_0_0[policyItemName]
}
